import React from 'react';
import { MenuSideBar } from '../../components/MenuSideBar';
import { PageWrapper } from './Page.styles';

function Page({ children }) {
  return (
    <PageWrapper>
      <MenuSideBar />
      {children}
    </PageWrapper>
  );
}

export default Page;
